export const GET_PRICE_CALENDAR_REQUEST = "GET_PRICE_CALENDAR_REQUEST";
export const GET_PRICE_CALENDAR_SUCCESS = "GET_PRICE_CALENDAR_SUCCESS";
export const GET_PRICE_CALENDAR_ERROR = "GET_PRICE_CALENDAR_ERROR";
export const SET_PRICE_CALENDAR_GO_INTENT = "SET_PRICE_CALENDAR_GO_INTENT";
export const SET_PRICE_CALENDAR_BACK_INTENT = "SET_PRICE_CALENDAR_BACK_INTENT";
export const TOGGLE_PRICE_CALENDAR_MINIMAP = "TOGGLE_PRICE_CALENDAR_MINIMAP";
export const TOGGLE_PRICE_CALENDAR_TRIP_TYPE = "TOGGLE_PRICE_CALENDAR_TRIP_TYPE";
export const PRICE_CALENDAR_RESET = "PRICE_CALENDAR_RESET";
export const PRICE_CALENDAR_MIN_SEARCH_INTENTS_LENGTH = 4;
